import { authFetch } from '../../common/networking/auth-fetch'
import {
  RequestResponse,
  ShortListResponse,
} from '../../types/requests/responses/request-response'
import { GetReportsResponse } from '../../types/requests/responses/get-reports-response'
import { PostReportsRequest } from '../../types/requests/requests/post-reports-request'
import { PostDeclineRequest } from '../../types/users/requests/post-decline-request'
import { PutRefundRequest } from '../../types/users/requests/put-refund-request'
import { PostProofRequest } from '../../types/users/requests/post-proof-request'
import { SkillAssessmentsOptions } from '../../types/requests/responses/skill-assessments-options'
import { PostSkillAssessments } from '../../types/requests/requests/post-skill-assessments'

export async function putUpdateRequestStatus(
  accessToken: any,
  request: {
    token: string
  },
): Promise<RequestResponse> {
  const response = await authFetch(accessToken).put(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/requests/status`,
    request,
  )
  return await response.json()
}

export async function getRequestByToken(
  accessToken: any,
  query: {
    token: string
  },
): Promise<RequestResponse> {
  const response = await authFetch(accessToken).get(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/requests?token=${query.token}`,
  )
  return await response.json()
}

export async function postDeclineRequestById(
  accessToken: any,
  request: PostDeclineRequest,
): Promise<Response> {
  return await authFetch(accessToken).post(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/requests/${request.id}/decline`,
    request,
  )
}

export async function putUpdateRequestStatusById(
  accessToken: any,
  request: {
    status: string
    id: number
  },
): Promise<RequestResponse> {
  const response = await authFetch(accessToken).put(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/requests/${request.id}/status`,
    request,
  )
  return await response.json()
}

export async function putRefundRequestById(
  accessToken: any,
  request: PutRefundRequest,
): Promise<RequestResponse> {
  const response = await authFetch(accessToken).put(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/requests/${request.id}/cancel`,
    request,
  )
  return await response.json()
}

export async function postProofRequestById(
  accessToken: any,
  request: PostProofRequest,
): Promise<Response> {
  return await authFetch(accessToken).post(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/requests/${request.id}/proof`,
    request,
  )
}

export async function postAskToCancelById(
  accessToken: any,
  request: {
    id: number
  },
): Promise<Response> {
  return await authFetch(accessToken).post(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/requests/${request.id}/ask-to-cancel`,
    request,
  )
}

export async function postReroll(
  accessToken: any,
  request: {
    requestId: number
  },
): Promise<RequestResponse> {
  const response = await authFetch(accessToken).post(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/checkout/reroll`,
    request,
  )
  return await response.json()
}

export async function postRerollTeammatesById(
  accessToken: any,
  request: {
    requestId: number
    teammateId: number
  },
): Promise<RequestResponse> {
  const response = await authFetch(accessToken).post(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/checkout/reroll/requests/${request.requestId}/teammates/${request.teammateId}`,
    request,
  )
  return await response.json()
}

export async function getReportsById(
  accessToken: any,
  id: number,
): Promise<GetReportsResponse> {
  const response = await authFetch(accessToken).get(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/reports/requests/${id}`,
  )
  return await response.json()
}

export async function postReports(
  accessToken: any,
  request: PostReportsRequest,
): Promise<Request> {
  const response = await authFetch(accessToken).post(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/reports`,
    request,
  )
  return await response.json()
}

export async function postSelectedTeammate(
  accessToken: any,
  requestId: number,
  teammateId: number,
): Promise<Response> {
  const response = await authFetch(accessToken).post(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/requests/${requestId}/short-list/teammates/${teammateId}`,
  )
  return response
}

export async function getShortListById(
  accessToken: any,
  shortListId: string,
): Promise<ShortListResponse> {
  const response = await authFetch(accessToken).get(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/requests/short-list/${shortListId}`,
  )
  return await response.json()
}

export async function getCheckShortListStatus(
  accessToken: any,
  requestId: number,
): Promise<Response> {
  const response = await authFetch(accessToken).get(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/requests/${requestId}/short-list/check-status`,
  )
  return response
}

export async function getSkillAssessmentsOptions(): Promise<
  SkillAssessmentsOptions[]
> {
  const response = await authFetch().get(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/requests/skill-assessment-options`,
  )
  return await response.json()
}

export async function postSkillAssessments(
  accessToken: any,
  request: PostSkillAssessments,
): Promise<Response> {
  const response = await authFetch(accessToken).post(
    `${process.env.NEXT_PUBLIC_DEFAULT_BASE_API_URL}/requests/${request.requestId}/skill-assessments`,
    request,
  )
  return response
}
